import styled from "styled-components"

interface ContainerProps {
  withError?: boolean
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  font-family: Ubuntu, sans-serif !important;

   @media (max-width: 610px) {
     width: 100%;
   }

  input {
    width: 100%;
    height: 45px;
    padding: 15px;
    font-size: 16px;
    border: 1px solid #C7C8DF !important;
    border-radius: 5px;
    background-color: white;

    ${({ withError }) => withError ? 'border-color: #FF4D57 !important;' : ''}
  }

  input, .react-datepicker {
    font-family: Ubuntu, sans-serif !important;
  }

  .react-datepicker__header {
    background-color: #FAFAFB;
  }

  .react-datepicker__triangle::after {
    border-bottom-color: #FAFAFB !important;
  }

  .react-datepicker__day--selected, 
  .react-datepicker__day--in-selecting-range, .react-datepicker__day--in-range {
    color: white !important;
    border-radius: 5px;
    background-color: #4D5EFF !important;
  }

  .react-datepicker__day:hover {
    background-color: #FAFAFB;
  }

  .react-datepicker__day--disabled {
    color: #C7C8DF;
  }

  .react-datepicker, .react-datepicker__header,
  .react-datepicker__time-container {
    border-color: #C7C8DF;
  }

  .react-datepicker__time-list-item--selected {
    background-color: #4D5EFF !important;
  }
`

export const Label = styled.span`
  font-size: 16px;
  margin-bottom: 10px;
`

export const InputsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;

  @media (max-width: 610px) {
    flex-direction: column;
    min-width: 100%;
  }
`

export const InputContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

  &:first-child {
    margin-right: 30px;

    @media (max-width: 610px) {
      margin-right: 0;
      margin-bottom: 20px;
    }
  }
`

export const ErrorMessage = styled.span`
  margin: 5px 0 0;
  font-size: 14px;
  color: #FF4D57;
`
